import React from 'react';
import { withRouter } from 'react-router';

class RouteChangeObserver extends React.Component {
    componentWillMount() {
        this.unlisten = this.props.history.listen((location, action) => {
            document.body.classList.remove('menu-open');
        });
    }
    componentWillUnmount() {
        this.unlisten();
    }

    render() {
        return null;
    }
}

export default withRouter(RouteChangeObserver);
